import gql from 'graphql-tag';

export const Organization = gql`
  query Organization($organizationId: ID!) {
    organization(organizationId: $organizationId) {
      id
      name
      status
      logo
      timezone
      locale
      featureFlags
      locations {
        id
        name
        color
      }
    }
  }
`;

export const OrganizationMinimal = gql`
  query OrganizationMinimal($organizationId: ID!) {
    organization(organizationId: $organizationId) {
      id
      name
      status
      logo
      timezone
      locale
      featureFlags
      mfaPolicy
    }
  }
`;
